import { render, staticRenderFns } from "./site-view-kpi-report.vue?vue&type=template&id=72f0077a&scoped=true"
import script from "./site-view-kpi-report.vue?vue&type=script&lang=ts"
export * from "./site-view-kpi-report.vue?vue&type=script&lang=ts"
import style0 from "./site-view-kpi-report.vue?vue&type=style&index=0&id=72f0077a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f0077a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f0077a')) {
      api.createRecord('72f0077a', component.options)
    } else {
      api.reload('72f0077a', component.options)
    }
    module.hot.accept("./site-view-kpi-report.vue?vue&type=template&id=72f0077a&scoped=true", function () {
      api.rerender('72f0077a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/site-view/sections/site-view-kpi-report.vue"
export default component.exports